import { store } from '@betacrew/jars-flux';
import { all, call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import SignInDataService from '../../../../services/SignInDataService';
import { setIsUserAuthenticated, setShowSessionError, setTwoFA } from '../../authentication/AuthenticationSlice';
import { PAGE_STATE } from '../../constants/constants';
import { componentKey, setShowError, resetSignInPage, setLoadingState, setShowTFAScreen, setUserGoogleProfile, setSignedInUserData } from './SignInSlice';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import axios from 'axios';
import { PRE_LOGIN_LOADING_STATES } from '../constants';

export const { signInUser, getSignInValidators, verifyTFACode, getUserGoogleProfile, loginWThirdParty } = {
    signInUser: (payload) => {
        return {
            type: "SIGN_IN/SIGN_IN_USER",
            payload: payload
        }
    },
    getSignInValidators: (payload) => {
        return {
            type: "SIGN_IN/SIGN_IN_VALIDATORS",
            payload: payload
        }
    },
    verifyTFACode: (payload) => {
        return {
            type: "SIGN_IN/VERIFY_TFA",
            payload: payload
        }
    },
    getUserGoogleProfile: (payload) => {
        return {
            type: "SIGN_IN/GET_USER_GOOGLE_PROFILE",
            payload: payload
        }
    },
    loginWThirdParty: (payload) => {
        return {
            type: "SIGN_IN/LOGIN_WITH_THIRD_PARTY",
            payload: payload
        }
    },
}
function* signInUserAsync(action) {
    try {
        yield put(setShowError({showError: false, errorMessage: ""}));
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.SIGN_IN_PAGE_LOADING }));
        const response = yield SignInDataService.signIn({...action.payload, password: btoa(btoa(action.payload.password))});
        if(response?.data){
            if(response?.data?.Status === 0){
                yield put(setShowError({showError: true, errorMessage: response?.data?.Message}));
            }else{
                if(response.data.Message === 'TFALogin') {
                    yield put(setTwoFA(true));
                    yield put(setShowTFAScreen(true));
                    yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.SIGN_IN_PAGE_READY }));
                } else {
                    yield put(setShowSessionError(false))
                    yield put(setIsUserAuthenticated(true));
                    yield put (setSignedInUserData({ EncUID : response?.data?.Data?.EncUID, Email: response.data.Data.Email  }))
                    yield put(resetSignInPage(true));
                }
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to sign in", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.SIGN_IN_PAGE_READY }));
    }
}

function* getSignInValidatorsAsync(action) {
    const response = yield SignInDataService.getSignInValidators();
}

function* verifyTFACodeAsync(action) {
    try {
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.SIGN_IN_PAGE_LOADING }));
        const response = yield SignInDataService.verifyTFACode(action.payload);
        if(response?.data){
            if (response?.data?.Status && response.data.Status === 1) {
                yield put(setIsUserAuthenticated(true));
                yield put(resetSignInPage(true));
            } else {
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.SIGN_IN_PAGE_READY }))
    }
}

function* getUserGoogleProfileAsync(action) {
    axios
        .get(`https://www.googleapis.com/oauth2/v1/userinfo`, {
            headers: {
                Authorization: `Bearer ${action.payload.access_token}`,
                Accept: 'application/json',
                withCredentials: true,
                "Access-Control-Allow-Origin": window.location.origin
            }
        })
        .then((res) => {
            setUserGoogleProfile(res);
        })
        .catch((err) => console.log(err));
}

function* loginWThirdPartyAsync(action){
    try {
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.SSO_SIGN_IN_PAGE_LOADING, message: "Signing in..." }));
        const response = yield SignInDataService.loginWThirdParty(action.payload);
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setIsUserAuthenticated(true));
        } else {
            yield put(addNotifications({
                heading: "Error",
                message: "An issue occurred while processing your request or there is no account present with your email. Please try again.",
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: "An issue occurred while processing your request or there is no account present with your email. Please try again.",
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.SSO_SIGN_IN_PAGE_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(signInUser().type, signInUserAsync),
        takeLatest(getSignInValidators().type, getSignInValidatorsAsync),
        takeLatest(verifyTFACode().type, verifyTFACodeAsync),
        takeLatest(getUserGoogleProfile().type, getUserGoogleProfileAsync),
        takeLatest(loginWThirdParty().type, loginWThirdPartyAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);